import { useCallback, useContext } from "react";
import { usePreferences } from "../Settings/Configuration/hooks/usePreferences";
import { ProfileContext } from "./context";

export const useIsFieldDisabled = (module) => {
	const config = usePreferences(module);
	const { user } = useContext(ProfileContext);

	return useCallback((key) => {
		return !config?.[key] && user?.isApi;
	}, [config, user?.isApi]);
};
